<div class="auth-component">
  <div *ngIf="!isLoggedIn() && !newUser" class="login-flexbox">
    <div class="login-part full-width">
      <div class="login-part-wrapper">
        <!--Language-->
        <div class="pull-right">
          <a (click)="showMenu($event, 0)" class="mat-list-item">
            <span class="btn-style">
              {{translate.instant('TOOLBAR.LANGUAGE')}} <i _ngcontent-hvq-21=""
                class="material-icons ic-arrow-drop-down">arrow_drop_down</i>
            </span>
            <div #dropdownmenu *ngIf="show[0]" class="dropdownmenu showThin">
              <ul>
                <li>
                  <nestas-lang></nestas-lang>
                </li>
              </ul>
            </div>
          </a>
        </div>
        <!-- /Language-->
        <img alt="Nestas Logo" class="logo" src="../../assets/NestasLogoHeader.png"  height="58" />
        <br /><br /><br />
        <div *ngIf="isIE">
          <div style="color:red">{{translate.instant('AUTH.IE_NOT_SUPPORTED1')}}</div>
          <div>{{translate.instant('AUTH.IE_NOT_SUPPORTED2')}}</div>

        </div>
        <div *ngIf="!isIE">
          <div class="title">{{translate.instant('AUTH.AUTHENTICATION_LOGIN')}}</div>

          <form class="full-width-form">
            <mat-form-field>
              <input matInput [(ngModel)]="user.email" class="full-width" type="email" name="email"
                [placeholder]="translate.instant('DATA.EMAIL')">
            </mat-form-field>
            <mat-form-field>
              <input matInput [(ngModel)]="user.password" class="full-width" type="password" name="password"
                [placeholder]="translate.instant('DATA.PASSWORD')" (keydown)="checkKey($event)">
            </mat-form-field>
          </form>
          <button mat-raised-button color="primary" (click)="logIn()" class="confirm-btn cursor"
            [disabled]="!user.email || !user.password">{{translate.instant('BUTTON.ACTION.LOGIN')}}
          </button>
          <a (click)="forgotPassword()"
            class="link link-margin">{{translate.instant('BUTTON.ACTION.FORGOT_PASSWORD')}}</a>
          <br />
          <br />
          <br />
          <!-- Facebook login button -->
          <!--
        <div class="full-width-form">
          <a class="facebook-a" href="/external/auth/facebook"><span>{{translate.instant('BUTTON.ACTION.LOGIN_FACEBOOK')}}</span></a>
        </div>
        <br />
        <br />-->
          <!-- LinkedIn login button -->
          <!--<div class="full-width-form">
          <a class="linkedin-a" href="/external/auth/linkedin"><span>{{translate.instant('BUTTON.ACTION.LOGIN_LINKEDIN')}}</span></a>
        </div>
        <br />
        <br />-->
        <!--(click)="startRegister()"-->
          <span>{{translate.instant('AUTH.NOTREGISTEREDYET')}}</span>&nbsp;<a href="https://www.nestas.eu/licentie/ik-open-een-digitaal-paspoort/" 
            class="link">{{translate.instant('BUTTON.ACTION.SIGNIN')}}</a>
        </div>
      </div>


    </div>
    <div class="image-part full-width">
      <div class="slogan">
        <div class="name">Nestas</div>
        {{translate.instant('AUTH.SLOGAN')}}
      </div>
    </div>
  </div>

  <div *ngIf="newUser" class="outside-login-box pull-right">
    <a (click)="showMenu($event, 1)" class="mat-list-item">
      <span class="btn-style">
        {{translate.instant('TOOLBAR.LANGUAGE')}} <i _ngcontent-hvq-21=""
          class="material-icons ic-arrow-drop-down">arrow_drop_down</i>
      </span>
      <div #dropdownmenu *ngIf="show[1]" class="dropdownmenu showThin">
        <ul>
          <li>
            <nestas-lang></nestas-lang>
          </li>
        </ul>
      </div>
    </a>
  </div>

  <mat-card *ngIf="newUser" class="login-box">
    <img (click)="newUser = null" alt="Nestas Logo" class="logo-nestas cursor" src="../../assets/NestasLogoHeader.png"
      width="80" height="" />
    <br /><br /><br />
    <mat-card-title>{{translate.instant('BUTTON.ACTION.SIGNIN')}}</mat-card-title>
    <br />
    <!-- Facebook sign-in button 

    <div class="full-width-form">
      <a class="facebook-a" href="/external/auth/facebook"><span>{{translate.instant('BUTTON.ACTION.SIGNIN_FACEBOOK')}}</span></a>
    </div>
    <br />
    <br />-->

    <!-- LinkedIn login button 
    <div class="full-width-form">
      <a class="linkedin-a" href="/external/auth/linkedin"><span>{{translate.instant('BUTTON.ACTION.SIGNIN_LINKEDIN')}}</span></a>
    </div>
    <br />
    <br /> -->

    <mat-card-subtitle>{{translate.instant('AUTH.AUTHENTICATION_INFORMATION')}}</mat-card-subtitle>
    <form class="full-width-form">
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.email" type="email" name="email"
          [placeholder]="translate.instant('DATA.EMAIL')">
      </mat-form-field>
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.password" type="password" name="password"
          [placeholder]="translate.instant('DATA.PASSWORD')">
      </mat-form-field>
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.confirm_password" type="password" name="confirm_password"
          [placeholder]="translate.instant('DATA.CONFIRM_PASSWORD')">
      </mat-form-field>
    </form>
    <br>
    <div class="alert-warning text-left"
      *ngIf="newUser.confirm_password && (newUser.password != newUser.confirm_password)">
      <i class="material-icons ic-warning">warning</i>{{translate.instant('MESSAGE.NOT_MATCH', {data:
      translate.instant('DATA.PASSWORD')})}}
    </div>
    <div *ngIf="newUser.confirm_password && (newUser.password != newUser.confirm_password)" class="alert-separator">
    </div>
    <div class="alert-info text-left" *ngIf="!passwordSecured()">
      <i class="material-icons ic-info">info</i>{{translate.instant('MESSAGE.ERROR.UNSECURE_PASSWORD')}}
    </div>
    <br /><br /><br />
    <mat-card-subtitle>{{translate.instant('AUTH.PERSONNAL_INFORMATION')}}</mat-card-subtitle>
    <form class="full-width-form">
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.profile.firstname" type="text" name="firstname"
          [placeholder]="translate.instant('DATA.FIRSTNAME')">
        <mat-hint *ngIf="!newUser.profile.firstname" align="end" color="warn" class="red">
          {{translate.instant('MESSAGE.IS_REQUIRED')}}
        </mat-hint>
      </mat-form-field>
      <br>
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.profile.lastname" type="text" name="lastname"
          [placeholder]="translate.instant('DATA.LASTNAME')">
        <mat-hint *ngIf="!newUser.profile.lastname" align="end" color="warn" class="red">
          {{translate.instant('MESSAGE.IS_REQUIRED')}}
        </mat-hint>
      </mat-form-field>
      <br>
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.profile.phone" type="phone" name="phone"
          [placeholder]="translate.instant('DATA.PHONE')">
      </mat-form-field>
    </form>

    <br /><br /><br />

    <mat-card-subtitle>{{translate.instant('DATA.ADDRESS')}}</mat-card-subtitle>
    <form class="full-width-form">
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.profile.address.address" type="text" name="address"
          [placeholder]="translate.instant('DATA.STREET_AND_NUMBER')">
        <mat-hint *ngIf="!newUser.profile.address.address" align="end" color="warn" class="red">
          {{translate.instant('MESSAGE.IS_REQUIRED')}}
        </mat-hint>
      </mat-form-field>
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.profile.address.zip" type="number" name="number"
          [placeholder]="translate.instant('DATA.ZIP')">
        <mat-hint *ngIf="!newUser.profile.address.zip" align="end" color="warn" class="red">
          {{translate.instant('MESSAGE.IS_REQUIRED')}}
        </mat-hint>
      </mat-form-field>
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.profile.address.city" type="text" name="city"
          [placeholder]="translate.instant('DATA.CITY')">
        <mat-hint *ngIf="!newUser.profile.address.city" align="end" color="warn" class="red">
          {{translate.instant('MESSAGE.IS_REQUIRED')}}
        </mat-hint>
      </mat-form-field>
      <mat-form-field>
        <input matInput [(ngModel)]="newUser.profile.address.country" type="text" name="country"
          [placeholder]="translate.instant('DATA.COUNTRY')">
        <mat-hint *ngIf="!newUser.profile.address.country" align="end" color="warn" class="red">
          {{translate.instant('MESSAGE.IS_REQUIRED')}}
        </mat-hint>
      </mat-form-field>
    </form>
    <br /><br /><br />

    <mat-card-subtitle>{{translate.instant('DATA.SENDFROMOPTION')}}</mat-card-subtitle>
    <form class="full-width-form">
      <label class="text-left">{{translate.instant('DATA.DOSENDFROM')}}</label>

      <select [(ngModel)]="newUser.profile.useFromEmail" (change)="updateUseFromEmail($event.target.value)"
        name="useFromEmail">
        <option value="1">Ja</option>
        <option value="0">Nee</option>
      </select>
      <div class="mat-input-hint-spacer mat-form-field-hint-spacer"></div>
      <mat-form-field *ngIf="newUser.profile.useFromEmail == '1'">
        <input matInput [(ngModel)]="newUser.profile.fromEmail" type="text" name="sendFrom"
          [placeholder]="translate.instant('DATA.SENDFROM')">

      </mat-form-field>


      <div class="info-group text-left" *ngIf="newUser.profile.useFromEmail">

        <label for='file' class="text-left">{{translate.instant('DATA.UPLOAD_LOGO')}}:</label>
        <div class="mat-input-hint-spacer mat-form-field-hint-spacer">&nbsp;</div>
        <img #imgPreview *ngIf="newUser.profile.logo.fileName" [src]="newUser.profile.logo.url" class="preview-logo" />

        <input type="file" name='file' id='file' (change)="fileChangeEvent($event)">
        <div class="mat-input-hint-spacer mat-form-field-hint-spacer">&nbsp;</div>

        <label class="text-left">{{translate.instant('NEW_PID.LOGO_INSTRUCTIONS')}}</label>

      </div>

    </form>
    <br /><br /><br />


    <button mat-raised-button color="primary" (click)="register()" [disabled]="!newUserIsValid()" class="confirm-btn">
      {{translate.instant('BUTTON.ACTION.REGISTER')}}
    </button>
    <br /><br />
    <a (click)="newUser = null" class="link">{{translate.instant('AUTH.ALREADY_HAVE_ACCOUNT')}}</a>
  </mat-card>
</div>